export default function getResource(label, vars = []) {
    const resources = {
        accessibilityOtpLegend: `Enter the ${vars[0]}-digit code sent to your email`,
        accessibilityOtpInput: `Verification code input ${vars[0]}`
    };

    return resources[label];
}
